<app-loading *ngIf="contentReady"></app-loading>

<div class="vcash-notifications-page" *ngIf="!contentReady" style="margin-bottom: 50px;">

  <!-- TOP HEADER -->
  <section class="vcash-top">
    <div class="vcash-appbar">
      <button class="appbar-btn" type="button" (click)="goBack()">
        <img [src]="isAr ? '/assets/e-commerce/icons/60.webp' : '/assets/e-commerce/icons/61.webp'" alt="back" />
      </button>

      <h1 class="appbar-title">{{ "notification" | transloco }}</h1>

      <div class="appbar-btn appbar-btn--ghost" routerLink="/wallet">
        <img src="/assets/e-commerce/icons/53.webp" alt="wallet" />
      </div>
    </div>
  </section>

  <!-- MAIN CONTENT -->
  <div class="vcash-content">

    <!-- SUMMARY CARD -->
    <section class="notify-summary-card">
      <div class="notify-summary-left">
        <span class="notify-overline">{{ "notification" | transloco }}</span>
        <h2>{{ notifications?.length || 0 }}</h2>
        <p>{{ "Latest updates for your account" | transloco }}</p>
      </div>

      <div class="notify-summary-icon">
        <img src="/assets/e-commerce/icons/55.webp" alt="notifications" />
      </div>
    </section>

    <!-- NOTIFICATIONS LIST -->
    <section class="notifications-card">

      @if(!notifications || notifications.length === 0){
      <div class="empty-wallet">
        <img src="/assets/e-commerce/icons/74.webp" alt="empty" class="product-img">
        <p class="no-data-text">{{ "No notifications" | transloco }}</p>
      </div>
      }
      @else{
      <div class="list-wrap">
        @for(notification of notifications; track notification.id || $index){
        <div class="notify-item" [class.offer]="notification.notification_type == 0">

          <div class="notify-icon-wrap">
            @if(notification.notification_type != 0){
            <img class="profile-icon" src="/assets/e-commerce/icons/55.webp" alt="notification">
            }
            @else{
            <img class="profile-icon" src="/assets/e-commerce/icons/66.webp" alt="offer">
            }
          </div>

          <div class="txt">
            @if(isAr){
            <div class="title">{{ notification.notification_head_ar }}</div>
            <div class="sub">{{ notification.notification_body_ar }}</div>
            }
            @else{
            <div class="title">{{ notification.notification_head_en }}</div>
            <div class="sub">{{ notification.notification_body_en }}</div>
            }
          </div>

        </div>
        }
      </div>
      }

    </section>
  </div>
</div>